"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
require("rxjs/add/observable/fromEvent");
var operators_1 = require("rxjs/operators");
var async_1 = require("rxjs/scheduler/async");
var leave_zone_scheduler_1 = require("../helpers/leave-zone.scheduler");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var SessionProlongService = /** @class */ (function () {
    function SessionProlongService(zone, httpClient, applicationPropertiesService) {
        this.zone = zone;
        this.httpClient = httpClient;
        this.applicationPropertiesService = applicationPropertiesService;
        this.pingIntervalDuration = 30 * 1000;
        this.activityEvents = Observable_1.Observable.merge(Observable_1.Observable.fromEvent(window, 'mousemove'), Observable_1.Observable.fromEvent(window, 'resize'), Observable_1.Observable.fromEvent(document, 'keydown'));
    }
    SessionProlongService.prototype.start = function () {
        var _this = this;
        this.idleSubscription = this.activityEvents.pipe(operators_1.auditTime(this.pingIntervalDuration, leave_zone_scheduler_1.leaveZone(this.zone, async_1.async))).subscribe(function () { return _this.ping(); });
    };
    SessionProlongService.prototype.stop = function () {
        if (this.idleSubscription) {
            this.idleSubscription.unsubscribe();
        }
    };
    SessionProlongService.prototype.ping = function () {
        var _this = this;
        this.applicationPropertiesService
            .getProperty('oauth-service-url')
            .then(function (url) {
            return _this.httpClient.put(url + "/token/prolong", null).toPromise();
        });
    };
    SessionProlongService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [core_1.NgZone, idm_authentication_client_js_1.HttpClientWrapper, idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], SessionProlongService);
    return SessionProlongService;
}());
exports.SessionProlongService = SessionProlongService;
//# sourceMappingURL=session-prolong.service.js.map